export const tabsNames = {
	basicInfo: 'basicInfo',
	schedule: 'schedule',
	channel: 'channel',
	customAlarm: 'customAlarm',
};

export const MAX_NUMBER_OF_REPETITIONS = 86400;
export const MIN_NUMBER_OF_REPETITIONS = 1;
export const STEP_NUMBER_OF_REPETITIONS = 10;
